import type { GtmEventName } from './gtmEvents';

export type GtmEventPayload = Record<string, unknown>;

declare global {
  interface Window {
    dataLayer?: Array<Record<string, unknown>>;
  }
}

export function isGtmEnabled(): boolean {
  return process.env.NEXT_PUBLIC_GTM_ENABLED === 'true';
}

export function pushGtmEvent(
  event: GtmEventName,
  payload: GtmEventPayload = {},
): void {
  if (typeof window === 'undefined' || !isGtmEnabled()) return;

  const cleanedPayload = Object.fromEntries(
    Object.entries(payload).flatMap(([key, value]) => {
      if (value === undefined) return [];
      return [[key, typeof value === 'string' ? value.trim() : value]];
    }),
  );

  try {
    window.dataLayer = window.dataLayer ?? [];
    window.dataLayer.push({ event, ...cleanedPayload });
  } catch {
    // Analytics must never interrupt the user flow.
  }
}
